import qs from "qs";
import crypto from 'crypto';
const hasOwn = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
const OPTIONS_KEYS = [
    'market',
    'sandbox',
    'timeout',
];
export function validateInteger(name, n, defaultVal) {
    if (!Number.isInteger(n)) {
        if (defaultVal !== undefined) {
            return defaultVal;
        }
        else {
            throw new Error(`${name} must be an integer`);
        }
    }
    return n;
}
;
export function pascalToCamelCase(name) {
    return name[0].toLowerCase() + name.substring(1);
}
;
export function extractUrlParams(path) {
    const params = path.match(/\{\w+\}/g);
    if (!params)
        return [];
    return params.map((param) => param.replace(/[{}]/g, ''));
}
export function callbackifyPromiseWithTimeout(promise, callback) {
    if (callback) {
        return promise.then(response => {
            setTimeout(() => {
                callback(null, response);
            }, 0);
        }, error => {
            setTimeout(() => {
                callback(error, null);
            }, 0);
        });
    }
    return promise;
}
export const makeURLInterpolator = (() => {
    const rc = {
        '\n': '\\n',
        '"': '\\"',
        '\u2028': '\\u2028',
        '\u2029': '\\u2029',
    };
    return (str) => {
        const cleanString = str.replace(/["\n\r\u2028\u2029]/g, ($0) => rc[$0]);
        return (outputs) => {
            return cleanString.replace(/\{([\s\S]+?)\}/g, ($0, $1) => encodeURIComponent(outputs[$1] || ''));
        };
    };
})();
function isOptionsHash(o) {
    return (o &&
        typeof o === 'object' &&
        (OPTIONS_KEYS.some((prop) => hasOwn(o, prop))));
}
export function getDataFromArgs(args) {
    if (!Array.isArray(args) || !args[0] || typeof args[0] !== 'object')
        return {};
    if (!isOptionsHash(args[0]))
        return args.shift();
    const argKeys = Object.keys(args[0]);
    const optionKeysInArgs = argKeys.filter((key) => OPTIONS_KEYS.includes(key));
    if (optionKeysInArgs.length > 0 &&
        optionKeysInArgs.length !== argKeys.length) {
        emitWarning(`Options found in arguments (${optionKeysInArgs.join(', ')}). Did you mean to pass an options object?`);
    }
    return {};
}
export function getOptionsFromArgs(args) {
    const opts = {
        auth: null,
        headers: {},
        settings: {},
    };
    if (args.length > 0) {
        const arg = args[args.length - 1];
        if (typeof arg === 'string') {
            opts.auth = args.pop();
        }
        else if (isOptionsHash(arg)) {
            const params = { ...args.pop() };
            if (params.apiKey) {
                opts.auth = params.apiKey;
            }
            if (Number.isInteger(params.timeout)) {
                opts.settings.timeout = params.timeout;
            }
        }
    }
    return opts;
}
export function stringifyRequestData(data) {
    return (qs
        .stringify(data, {
        serializeDate: (d) => Math.floor(d.getTime() / 1000),
    })
        .replace(/%5B/g, '[')
        .replace(/%5D/g, ']'));
}
export function protoExtend(sub) {
    const Super = this;
    const Constructor = hasOwn(sub, 'constructor')
        ? sub.constructor
        : function (...args) {
            Super.apply(this, args);
        };
    Object.assign(Constructor, Super);
    Constructor.prototype = Object.create(Super.prototype);
    Object.assign(Constructor.prototype, sub);
    return Constructor;
}
export function removeNullish(obj) {
    if (typeof obj !== 'object')
        throw new Error('Argument must be an object');
    return Object.keys(obj).reduce((result, key) => {
        if (obj[key] != null)
            result[key] = obj[key];
        return result;
    }, {});
}
export function normalizeHeaders(obj) {
    if (!(obj && typeof obj === 'object'))
        return obj;
    return Object.keys(obj).reduce((result, header) => {
        result[normalizeHeader(header)] = obj[header];
        return result;
    }, {});
}
export function computeHmacSha256(payload, secret) {
    const hmac = crypto.createHmac('sha256', secret);
    return hmac.update(payload, 'utf8').digest('hex');
}
function emitWarning(warning) {
    if (typeof process.emitWarning !== 'function') {
        return console.warn(`> Lalamove - ${warning}`);
    }
    return process.emitWarning(warning, 'Lalamove');
}
export function emitInfo(info) {
    if (typeof process.emitInfo !== 'function') {
        if (typeof info === 'object') {
            info = JSON.stringify(info);
        }
        return console.info(`> Lalamove - ${info}`);
    }
    return process.emitInfo(info, 'Lalamove');
}
//# sourceMappingURL=utils.js.map